import { Component, DestroyRef, inject } from '@angular/core';
import { } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UdlControlledVocabulary } from '../../../../shared/models/udl-controlled-vocabulary.model';
import { UdlControlledVocabularyService } from '../../udl-controlled-vocabulary.service';

@Component({
  selector: 'app-udl-user-resources',
  template: `
<div ngClass="container flex h-full">
    <div class="resource-grid grid-container">
      <app-grid #grid [columnDefs]="columnsDef" [rowData]="dataRows" [pagination]="false"
        [autosize]="true" [autoAdjustColumns]="false" [useAddAction]="false" 
      ></app-grid>
    </div>

</div>
  `,
  styleUrls: ['./udl-user-resources.component.css'],
})
export class UDLUserResourcesComponent {
  private controlledVocabularyService: UdlControlledVocabularyService = inject(UdlControlledVocabularyService);
  private destroyRef = inject(DestroyRef)

  columnsDef = [
    { headerName: 'Resource', field: 'title', editable: false, resizable: false, width: 200, cellRenderer: (params: any) => {
      return `<a href="${params.data.url}" target="_blank">${params.value}</a>`;
    }},
    { headerName: 'Description', field: 'description', editable: false, resizable: false, width: 750 },
  ];

  dataRows = [] as { title: string, description: string, url: string }[];

  constructor() { 
    this.refreshData()
  }

  refreshData() {
    this.controlledVocabularyService.getControlledVocabularyItemsByKey("UserResources").pipe(takeUntilDestroyed(this.destroyRef)).subscribe(items => {
      this.dataRows = items.map((item: UdlControlledVocabulary) => {
        return {
          title: item.short_value || "",
          description: item.long_value || "",
          url: item.metadata || ""
        }
      });
    });
  }
}